import Vue from "vue";
import Vuex from "vuex";
import Vuer from "vue-router";
import Vuem from "vue-moment";
import Vuet from "vue-sweetalert2";
import Vues from "vue-signature-pad";
import Vuel from 'vuejs-loading-plugin';
import Vtip from "vue-directive-tooltip";
import Tree from 'liquor-tree'
import AOS from 'aos';
import App from "./App.vue";
import https from './services/';
import routes from "./routes/";
import stores from "./stores/";
import helps from "./helpers/";
import number from 'written-number'
import VueGtag from 'vue-gtag';
import components from "./components/";
import PrimeVue from 'primevue/config';
import OrderList from 'primevue/orderlist';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import PickList from 'primevue/picklist';
import { BootstrapVue, IconsPlugin, TablePlugin } from "bootstrap-vue";
import { extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import _fr from 'vee-validate/dist/locale/fr.json';
import moment from 'moment';
import { kebabCase, lowerCase, deburr, reduce, get } from 'lodash';
import "bootstrap";
import 'slick-carousel';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import i18n from "./i18n";
import "./helpers/filters";
import VueToast from 'vue-toast-notification';

import 'vue-toast-notification/dist/theme-default.css';
// import 'vue-toast-notification/dist/theme-bootstrap.css';

global.$ = $;
global.jQuery = $;

 const router = new Vuer(routes);



Vue.use(PrimeVue);
Vue.use(Vuex).use(VueToast).use(Vuer).use(Vuet).use(Vues).use(Vtip).use(Tree).use(components).use(Vuem, { moment }).use(Vuel, {
    dark: true, // default false
    text: 'Chargement ...', // default 'Loading'
    // loading: true, // default false
    // customLoader: myVueComponent, // replaces the spinner and text with your own
    // background: 'rgb(255,255,255)', // set custom background
    // classes: ['myclass'] // array, object or string
})
    .use(VueGtag, {
        config: { id: "G-RX2NML06M4" }
    }, router);

Vue.use(CKEditor)

Vue.component('InterPhone', VuePhoneNumberInput);
Vue.component('OrderList', OrderList);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('PickList', PickList);
Vue.component('multi-select', Multiselect);

Vue.filter('moment', function (value, format = 'DD-MM-YYYY HH:mm') {
  return moment(value).format(format);
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(TablePlugin);

Vue.directive("uppercase", {
    update: function (el) {
        const sourceValue = el.value;
        const newValue = sourceValue.toUpperCase();
        if (sourceValue !== newValue) {
            el.value = newValue;
            el.dispatchEvent(new Event("input", { bubbles: true }));
        }
    }
});

Vue.config.productionTip = false;
const store = new Vuex.Store(stores);
router.beforeEach(
    async (to, from, next) =>
        await helps.middleware({ to, store, next })
);
https.interceptors.response.use(undefined, err => helps.interceptor(err, store, router));
Vue.prototype.$can = (required) => {
    const user = store.getters['auth/user'];
    if (!user) return false;

    const roles = [
        ...(user.roles || []),
        ...(user.clientRoles || [])
    ].map(r => r.toUpperCase());

    return helps.grant(roles, required);
};

Vue.prototype.$swat = Vue.swal.mixin({
    position: 'top-end',
    icon: 'success',
    title: 'Your work has been saved',
    showConfirmButton: false,
    timerProgressBar: true,
    toast: true,
    timer: 3000
})
Vue.mixin({
    methods: {
        onUrl(value = {}) {
            return `${process.env.VUE_APP_API_URL}/uploads/${value.value}`;
        },
        letterOf: value => number(value, { lang: 'fr' }),
        currency: value => parseInt(value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& '),
        slugify: str => kebabCase(lowerCase(deburr(str))),
        filterBy(list, value, key = 'name') {
            const regexp = new RegExp(value, 'gi');
            return list.filter(obj => obj[key].match(regexp))
        },
        csvExport: (list = [], map = {}, filename = 'export') => {
            const keys = Object.keys(map);
            const sources = reduce(list, (result, value) => {
                result.push(keys.map(key => get(value, key, '')));
                return result;
            }, [Object.values(map)]).map(row => JSON.stringify(row).replace(/\[(.*)\]/i, '$1')).join('\n');
            const fileURL = URL.createObjectURL(new Blob([sources], { type: 'text/csv' })),
                link = document.createElement('a');

            link.setAttribute('style', 'display: none;');
            link.setAttribute('_target', 'blank');
            link.setAttribute('download', `${filename}.csv`);
            link.setAttribute('href', fileURL);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        fileLoad(value, object) {
            let reader = new FileReader(), files = value.target.files || value.dataTransfer.files;
            if (!files.length) return;
            reader.readAsDataURL(files[0]);
            Vue.set(object, 'file', { name: files[0].name, url: URL.createObjectURL(files[0]) });
            //console.log(object)
            reader.onload = e => Vue.set(object, 'tmp', e.target.result);
        },
        fileLoadValid(value, object, nomFichier) {
            let reader = new FileReader(), files = value.target.files || value.dataTransfer.files;
            var res1 = files[0].name.replace('.PDF', "");
            var res2 = res1.replace('.pdf', "");
            //var nomSansExtension = files[0].name.split(".");
            if (nomFichier !== res2) {
                this.$swal('Sélection de Fichier', 'Le fichier choisi n\'est pas correct!', 'warning');
                return;
            } else {
                if (!files.length) return;
                reader.readAsDataURL(files[0]);
                Vue.set(object, 'file', { name: files[0].name, url: URL.createObjectURL(files[0]) });
                reader.onload = e => Vue.set(object, 'tmp', e.target.result);
            }
        },
        fileLoadOne(value, object, tables) {
            let reader = new FileReader(), files = value.target.files || value.dataTransfer.files;
            //Parcourir les anciens fichiers chargés
            for (let i = 0; i < tables.length; i++) {
                const element = tables[i];
                //Si le nouveau fichier avait été déjà chargé, ne rien faire
                if (element?.file?.name === files[0].name) {
                    this.$swal('Sélection de Fichier', 'Le fichier choisi est déjà présent!', 'warning');
                    return;
                }
                else if (tables.length === i + 1) {
                    //Lorsque tout le tableau a été parcourir sans rien trouver, exécuter le chargement du fichier
                    if (!files.length) return;
                    reader.readAsDataURL(files[0]);
                    Vue.set(object, 'file', { name: files[0].name, url: URL.createObjectURL(files[0]) });
                    reader.onload = e => Vue.set(object, 'tmp', e.target.result);
                }
            }
        },
        async webFileLoad(value, object) {
            let reader = new FileReader();
            var file = await fetch(value);
            const ImgBlob = await file.blob();
            const imageUrl = URL.createObjectURL(ImgBlob);
            reader.readAsDataURL(ImgBlob);
            Vue.set(object, 'file', { name: value.split("/")[5], url: imageUrl });
            console.log(object)
            reader.onload = e => Vue.set(object, 'tmp', e.target.result);
        },
    },
});

for (const rule of Object.keys(rules)) extend(rule, rules[rule]); //Vue.filter("firster", value => value.charAt(0).toUpperCase()); Vue.filter("formate", (value, format = "Do MMM YYYY") => moment(value).format(format));

Object.defineProperties(Vue.prototype, { $http: { get: () => https } }); //Object.keys(rules).forEach(rule => extend(rule, rules[rule]));

extend('numeric_with_comma', {
    validate(value) {
        const normalized = value.replace(',', '.');
        return !isNaN(normalized) && isFinite(normalized);
    },
    message: 'Le champ doit être un nombre valide.'
});

extend('hasImages', {
    validate(value) {
        return Array.isArray(value) && value.length > 0;
    },
    message: 'Veuillez ajouter au moins une image du produit.'
});

extend("date_format_yyyy_mm_dd", {
    validate(value) {
        return /^\d{4}-\d{2}-\d{2}$/.test(value);
    },
    message: "Le format de la date doit être AAAA-MM-JJ"
});

extend('integer', {
    message: 'Ce champ doit être un nombre uniquement'
});

extend('containsUppercase', value => {
    if (/[A-Z]/.test(value)) {
        return true;
    }

    return 'Le champ {_field_} doit contenir au moins une lettre majuscule';
});

extend('codePays', value => {
    if (value.includes("+")) {
        return true;
    }

    return 'Le Pays doit être sélectionné';
});

extend('containsLowercase', value => {
    if (/[a-z]/.test(value)) {
        return true;
    }

    return 'Le champ {_field_} doit contenir au moins une lettre miniscule';
});

extend('containsNumber', value => {
    if (/[0-9]/.test(value)) {
        return true;
    }

    return 'Le champ {_field_} doit contenir au moins un nombre';
});

extend('email', {
    message: 'L\'e-mail doit être une adresse de format conforme'
});

extend('valideFiles', value => {
    console.log(value)
    var start = true;
    for (let i = 0; i < value.length; i++) {
        const element = value[i];
        if (!element.name) { start = false }
        /* else if(!element.file.url){
            start = false;
            //Object.entries(element.file).length === 0 ? start = false : null;
        } */console.log(start)
        if (parseInt(value.length - 1) === i) return start;
    }
});

window.index = window.index || function () {};

localize(_fr.code, _fr);
moment.locale('fr');

store.dispatch('auth/restoreSession').then(() => {
    new Vue({
        store,
        router,
        created() {
            AOS.init();
        },
        i18n,
        render: h => h(App)
    }).$mount("#app");
});


